import React from "react";
import { Grid, Typography, Chip } from "@mui/material";

import request from "../../../../utilities/requests";

const UserStats = ({search}) => {
  const [data, setData] = React.useState(null);

  React.useEffect(() => {
    if (!data) {
      getData();
    }
  });

  const getData = async () => {
    const result = await request("matchmaking/usercount");
    if (result.success) {
      setData(result.data);
    }
  };


  return (
    <Grid container direction="row">
      <Grid item xs={4} style={{display:'flex', justifyContent:'center'}}>
        <Chip label={`Free: ${data?.free}`} style={{cursor:'pointer'}} onClick={()=> search({matchmakingTier: 1})}/>
      </Grid>
      <Grid item xs={4} style={{display:'flex', justifyContent:'center'}}>
      <Chip label={`Silver: ${data?.silver}`} style={{cursor:'pointer'}} onClick={()=> search({matchmakingTier: 2})}/>
      </Grid>
      <Grid item xs={4} style={{display:'flex', justifyContent:'center'}}>
      <Chip label={`Gold: ${data?.gold}`} style={{cursor:'pointer'}} onClick={()=> search({matchmakingTier: 3})}/>
      </Grid>
    </Grid>
  );
};

export default UserStats;
